import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ZoomableImage from "./ZoomableImage";

const ZoomDialog = ({ open, image, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
    <DialogTitle>
      Zoom Image
      <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent dividers sx={{ height: "80vh" }}>
      <ZoomableImage src={image} />
    </DialogContent>
  </Dialog>
);

export default ZoomDialog;
